/* Ambient theme — vanilla JS, no dependencies */
(() => {
  'use strict';

  const T = window.theme || { routes: {}, strings: {} };
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const debounce = (fn, ms = 250) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };
  const root = (T.routes.root || '/').replace(/\/$/, '');
  const store = {
    get(key) { try { return JSON.parse(localStorage.getItem(key)) || []; } catch (e) { return []; } },
    set(key, val) { try { localStorage.setItem(key, JSON.stringify(val)); } catch (e) { /* storage blocked */ } }
  };

  /* ---------- Toast ---------- */
  const toastEl = $('[data-toast]');
  let toastTimer;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toastEl.classList.remove('is-visible'), 2800);
  }

  /* ---------- Overlays: drawers + search ---------- */
  let lastFocus = null;
  const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';

  function trapFocus(container, e) {
    const items = $$(FOCUSABLE, container).filter((el) => el.offsetParent !== null);
    if (!items.length) return;
    const first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function openDrawer(id) {
    const drawer = document.getElementById(id);
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    requestAnimationFrame(() => drawer.classList.add('is-open'));
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    const focusTarget = $(FOCUSABLE, $('.drawer__panel', drawer));
    setTimeout(() => focusTarget && focusTarget.focus(), 50);
  }
  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-locked');
    if (lastFocus) lastFocus.focus();
  }

  const searchModal = $('[data-search-modal]');
  function openSearch() {
    if (!searchModal) return;
    lastFocus = document.activeElement;
    searchModal.hidden = false;
    document.body.classList.add('is-locked');
    setTimeout(() => { const i = $('input[type="search"]', searchModal); i && i.focus(); }, 30);
  }
  function closeSearch() {
    if (!searchModal || searchModal.hidden) return;
    searchModal.hidden = true;
    document.body.classList.remove('is-locked');
    if (lastFocus) lastFocus.focus();
  }

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      if (opener.dataset.drawerOpen === 'CartDrawer' && T.cartType !== 'drawer') return;
      e.preventDefault(); openDrawer(opener.dataset.drawerOpen); return;
    }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('.drawer')); return; }
    if (e.target.closest('[data-open-search]')) { e.preventDefault(); openSearch(); return; }
    if (e.target.closest('[data-close-search]')) { e.preventDefault(); closeSearch(); }
  });

  document.addEventListener('keydown', (e) => {
    const openDrawerEl = $('.drawer.is-open');
    if (e.key === 'Escape') { closeDrawer(openDrawerEl); closeSearch(); }
    if (e.key === 'Tab') {
      if (openDrawerEl) trapFocus($('.drawer__panel', openDrawerEl), e);
      else if (searchModal && !searchModal.hidden) trapFocus(searchModal, e);
    }
  });

  /* ---------- Header / tab bar / back-to-top scroll behaviour (class toggles only — no layout changes) ---------- */
  const shell = $('[data-header-shell]');
  const tabbar = $('[data-tabbar]');
  const backTop = $('[data-back-top]');
  {
    let lastY = window.scrollY;
    let ticking = false;
    const hideOnScroll = shell && shell.dataset.hideOnScroll === 'true';
    const mobile = window.matchMedia('(max-width: 989px)');
    let scrolled = null, hidden = null, tabHidden = null, topShown = null;
    const set = (el, cls, on, cache) => { if (el && cache !== on) el.classList.toggle(cls, on); return on; };
    const onScroll = () => {
      const y = Math.max(0, window.scrollY);
      const dy = y - lastY;
      if (Math.abs(dy) > 6 || y < 10) {
        const down = dy > 0;
        scrolled = set(shell, 'is-scrolled', y > 24, scrolled);
        if (hideOnScroll) hidden = set(shell, 'is-hidden', mobile.matches && down && y > 220 && !document.body.classList.contains('is-locked'), hidden);
        tabHidden = set(tabbar, 'is-hidden', down && y > 300, tabHidden);
        topShown = set(backTop, 'is-visible', y > 1200, topShown);
        lastY = y;
      }
      ticking = false;
    };
    window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
    onScroll();
    if (backTop) backTop.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  }

  /* ---------- Tabs row: sliding glass pill + mega panels with page blur ---------- */
  const nav = $('[data-nav]');
  if (nav) {
    const pill = $('[data-nav-pill]', nav);
    const items = $$('[data-nav-item]', nav);
    const megas = $$('[data-mega]', nav);
    const hoverable = window.matchMedia('(hover: hover) and (min-width: 990px)');
    const movePill = (li) => {
      if (!pill) return;
      if (!li) { pill.style.opacity = '0'; return; }
      const a = $('.nav__link', li);
      pill.style.transform = 'translate3d(' + a.offsetLeft + 'px,0,0)';
      pill.style.width = a.offsetWidth + 'px';
      pill.style.opacity = '1';
    };
    const current = items.find((li) => $('.nav__link[aria-current]', li));
    let closeTimer, openTimer;
    const closeAll = () => {
      clearTimeout(openTimer);
      megas.forEach((m) => m.classList.remove('is-open'));
      $$('[data-mega-toggle]', nav).forEach((t) => t.setAttribute('aria-expanded', 'false'));
      document.body.classList.remove('menu-open');
    };
    const openFor = (li) => {
      clearTimeout(closeTimer);
      const id = li.dataset.megaFor;
      megas.forEach((m) => m.classList.toggle('is-open', m.id === id));
      $$('[data-mega-toggle]', nav).forEach((t) => t.setAttribute('aria-expanded', String(t.getAttribute('aria-controls') === id)));
      document.body.classList.toggle('menu-open', !!id);
    };
    items.forEach((li) => {
      li.addEventListener('mouseenter', () => {
        movePill(li);
        if (!hoverable.matches) return;
        clearTimeout(openTimer);
        openTimer = setTimeout(() => { if (li.dataset.megaFor) openFor(li); else closeAll(); }, 90);
      });
      li.addEventListener('focusin', () => movePill(li));
      const toggle = $('[data-mega-toggle]', li);
      if (toggle) {
        toggle.addEventListener('click', (e) => {
          if (!hoverable.matches) return; // touch: follow the link
          const open = toggle.getAttribute('aria-expanded') === 'true';
          if (!open) { e.preventDefault(); openFor(li); }
        });
        toggle.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowDown' || e.key === 'Enter' && toggle.getAttribute('aria-expanded') !== 'true') {
            e.preventDefault(); openFor(li);
            const first = $('#' + li.dataset.megaFor + ' a, #' + li.dataset.megaFor + ' input');
            if (first) first.focus();
          }
        });
      }
    });
    nav.addEventListener('mouseleave', () => { movePill(current); clearTimeout(openTimer); closeTimer = setTimeout(closeAll, 200); });
    nav.addEventListener('mouseenter', () => clearTimeout(closeTimer));
    document.addEventListener('click', (e) => { if (!e.target.closest('[data-nav]')) closeAll(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(); });
    const veil = $('[data-page-veil]');
    if (veil) veil.addEventListener('click', closeAll);
    window.addEventListener('resize', debounce(() => movePill(current), 150));
    requestAnimationFrame(() => { movePill(current); if (current) current.scrollIntoView({ block: 'nearest', inline: 'center' }); });
    // live brand filter inside the brand panel
    $$('[data-brand-filter]', nav).forEach((input) => {
      const list = $('[data-brand-list]', input.closest('[data-mega]'));
      input.addEventListener('input', () => {
        const q = input.value.trim().toLowerCase();
        $$('a[data-brand]', list).forEach((a) => { a.hidden = q && !a.dataset.brand.includes(q); });
        $$('.brand-az__letter', list).forEach((l) => { l.hidden = !!q; });
      });
    });
  }

  /* ---------- Announcement rotator ---------- */
  $$('[data-announcement]').forEach((bar) => {
    const items = $$('.announcement__item', bar);
    if (items.length < 2) return;
    let i = 0;
    const speed = (parseInt(bar.dataset.speed, 10) || 5) * 1000;
    setInterval(() => {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, speed);
  });

  /* ---------- Predictive search ---------- */
  const pInput = $('[data-predictive-input]');
  const pResults = $('[data-predictive-results]');
  if (pInput && pResults && T.routes.predictiveSearch) {
    let controller;
    const run = debounce(async () => {
      const q = pInput.value.trim();
      if (!q) { pResults.innerHTML = ''; pInput.setAttribute('aria-expanded', 'false'); return; }
      if (controller) controller.abort();
      controller = new AbortController();
      try {
        const url = `${T.routes.predictiveSearch}?q=${encodeURIComponent(q)}&section_id=predictive-search&resources[type]=product,collection,article,page&resources[limit]=8&resources[options][unavailable_products]=last`;
        const res = await fetch(url, { signal: controller.signal });
        if (!res.ok) throw new Error(res.status);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const inner = $('#shopify-section-predictive-search', doc);
        pResults.innerHTML = inner ? inner.innerHTML : '';
        pInput.setAttribute('aria-expanded', 'true');
      } catch (err) { if (err.name !== 'AbortError') pResults.innerHTML = ''; }
    }, 220);
    pInput.addEventListener('input', run);
  }

  /* ---------- Cart ---------- */
  const cartDrawerId = 'CartDrawer';

  function updateCount(count) {
    $$('[data-cart-count]').forEach((el) => { el.textContent = count > 0 ? count : ''; });
  }

  function renderCartDrawer(html) {
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = $('[data-cart-drawer-inner]', doc);
    const current = $('[data-cart-drawer-inner]');
    if (fresh && current) {
      current.replaceWith(fresh);
      const count = parseInt(fresh.dataset.cartCount, 10) || 0;
      updateCount(count);
      initDispatch(fresh);
      document.dispatchEvent(new CustomEvent('ambient:cart', { detail: { el: fresh, count } }));
    }
  }

  async function refreshCart() {
    if (T.cartType !== 'drawer') return;
    const res = await fetch(`${root}/?sections=cart-drawer`);
    const data = await res.json();
    renderCartDrawer(data['cart-drawer']);
  }

  async function addToCart(form, submitter) {
    const btn = submitter || $('[type="submit"]', form);
    const errorBox = $('[data-form-error]', form.closest('[data-product-section]') || form);
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-disabled', 'true'); }
    if (errorBox) errorBox.hidden = true;
    try {
      const fd = new FormData(form);
      fd.append('sections', 'cart-drawer');
      fd.append('sections_url', window.location.pathname);
      const res = await fetch(`${T.routes.cartAdd}.js`, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd });
      const data = await res.json();
      if (!res.ok || data.status) {
        const msg = data.description || data.message || T.strings.cartError;
        if (errorBox) { errorBox.textContent = msg; errorBox.hidden = false; } else { toast(msg); }
        return;
      }
      if (data.sections) renderCartDrawer(data.sections['cart-drawer']);
      openDrawer(cartDrawerId);
    } catch (err) {
      toast(T.strings.cartError);
    } finally {
      if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-disabled'); }
    }
  }

  async function changeLine(line, quantity) {
    const inner = $('[data-cart-drawer-inner]');
    if (inner) inner.style.opacity = '.55';
    try {
      const res = await fetch(`${T.routes.cartChange}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections: ['cart-drawer'], sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (!res.ok || data.status) { toast(data.description || data.message || T.strings.cartError); refreshCart(); return; }
      renderCartDrawer(data.sections && data.sections['cart-drawer']);
    } catch (err) { toast(T.strings.cartError); }
    finally { const el = $('[data-cart-drawer-inner]'); if (el) el.style.opacity = ''; }
  }

  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!form.matches('[data-ajax-cart]') || T.cartType !== 'drawer') return;
    e.preventDefault();
    addToCart(form, e.submitter);
  });

  // Drawer quantity + remove (delegated, survives re-render)
  document.addEventListener('click', (e) => {
    const rm = e.target.closest('[data-cart-remove]');
    if (rm && rm.closest('[data-cart-drawer-inner]')) { e.preventDefault(); changeLine(+rm.dataset.line, 0); }
  });
  const drawerQty = debounce((input) => changeLine(+input.dataset.line, Math.max(0, parseInt(input.value, 10) || 0)), 350);
  document.addEventListener('change', (e) => {
    const input = e.target;
    if (input.matches('[data-cart-qty]') && input.closest('[data-cart-drawer-inner]')) drawerQty(input);
    if (input.matches('[data-cart-page-qty]')) cartPageSubmit(input.form);
  });
  const cartPageSubmit = debounce((form) => form && form.submit(), 600);

  // Cart note (drawer) — persist with cart/update
  document.addEventListener('input', debounce((e) => {
    if (!e.target.matches('[data-cart-note]')) return;
    fetch(`${root}/cart/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: e.target.value }) });
  }, 500));

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty-btn]');
    if (!b) return;
    e.preventDefault();
    const input = $('input', b.closest('.qty'));
    if (!input) return;
    const min = parseInt(input.min, 10) || 0;
    const step = parseInt(input.step, 10) || 1;
    const max = input.max ? parseInt(input.max, 10) : Infinity;
    let v = parseInt(input.value, 10) || 0;
    v = b.dataset.qtyBtn === 'plus' ? Math.min(max, v + step) : Math.max(min, v - step);
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product: variant picker + gallery ---------- */
  $$('[data-product-section]').forEach(initProduct);

  function initProduct(section) {
    const picker = $('[data-variant-picker]', section);
    const jsonEl = $('[data-product-json]', section);
    const form = $('form[data-product-form]', section);
    const idInput = form && $('input[name="id"]', form);
    const sectionId = section.dataset.sectionId;
    const productUrl = section.dataset.productUrl;
    const gallery = $('[data-gallery]', section);

    if (gallery) initGallery(gallery);

    // recently viewed tracking
    if (T.recentlyViewed && section.dataset.handle) {
      const list = store.get('ambient:recent').filter((h) => h !== section.dataset.handle);
      list.unshift(section.dataset.handle);
      store.set('ambient:recent', list.slice(0, 12));
    }

    // sticky add-to-cart
    const sticky = $('[data-sticky-atc]', section);
    const mainAtc = $('[data-main-atc]', section);
    if (sticky && mainAtc && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        const past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', past);
        sticky.setAttribute('aria-hidden', String(!past));
      }).observe(mainAtc);
    }

    if (!picker || !jsonEl || !idInput) return;
    const product = JSON.parse(jsonEl.textContent);

    const currentOptions = () => $$('fieldset', picker).map((fs) => {
      const checked = $('input:checked', fs);
      const sel = $('select', fs);
      return checked ? checked.value : sel ? sel.value : null;
    });

    function markAvailability(selected) {
      $$('fieldset', picker).forEach((fs, idx) => {
        $$('input[type="radio"]', fs).forEach((input) => {
          const test = selected.slice();
          test[idx] = input.value;
          const ok = product.variants.some((v) => v.available && v.options.every((o, i) => i === idx || o === test[i]) && v.options[idx] === input.value);
          input.classList.toggle('is-unavailable', !ok);
        });
        const legendValue = $('[data-selected-value]', fs);
        if (legendValue) legendValue.textContent = selected[idx];
      });
    }

    picker.addEventListener('change', async () => {
      const selected = currentOptions();
      markAvailability(selected);
      const variant = product.variants.find((v) => v.options.every((o, i) => o === selected[i]));
      const atcButtons = $$('[data-atc]', section);

      if (!variant) {
        atcButtons.forEach((b) => { b.disabled = true; $('[data-atc-text]', b).textContent = T.strings.unavailable; });
        return;
      }

      idInput.value = variant.id;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
      atcButtons.forEach((b) => {
        b.disabled = !variant.available;
        $('[data-atc-text]', b).textContent = variant.available ? T.strings.addToCart : T.strings.soldOut;
      });

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());

      if (variant.featured_media && gallery) gallery.goTo(String(variant.featured_media.id));

      // Re-render price / inventory / sku with Section Rendering API (keeps money formatting server-side)
      try {
        const res = await fetch(`${productUrl}?variant=${variant.id}&section_id=${sectionId}`);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        $$('[data-swap]', section).forEach((el) => {
          const fresh = $(`[data-swap="${el.dataset.swap}"]`, doc);
          if (fresh) el.innerHTML = fresh.innerHTML;
        });
      } catch (err) { /* keep current markup */ }
    });

    markAvailability(currentOptions());
  }

  function initGallery(gallery) {
    const track = $('[data-gallery-track]', gallery);
    const slides = $$('[data-media-id]', track);
    const thumbs = $$('[data-thumb]', gallery);
    const dots = $$('[data-dot]', gallery);

    const setActive = (idx) => {
      thumbs.forEach((t, i) => t.setAttribute('aria-current', String(i === idx)));
      dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
    };
    gallery.goTo = (mediaId) => {
      const idx = slides.findIndex((s) => s.dataset.mediaId === mediaId);
      if (idx < 0) return;
      const isGrid = getComputedStyle(track).display === 'grid';
      if (isGrid) slides[idx].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      else track.scrollTo({ left: slides[idx].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      setActive(idx);
    };
    thumbs.forEach((t) => t.addEventListener('click', () => gallery.goTo(t.dataset.thumb)));
    track.addEventListener('scroll', debounce(() => {
      const idx = Math.round(track.scrollLeft / (track.clientWidth || 1));
      setActive(Math.min(idx, slides.length - 1));
    }, 60), { passive: true });
  }

  /* ---------- Wishlist ---------- */
  const WKEY = 'ambient:wishlist';
  function syncWishlistUI() {
    const list = store.get(WKEY);
    $$('[data-wishlist-toggle]').forEach((btn) => {
      const on = list.includes(btn.dataset.handle);
      btn.setAttribute('aria-pressed', String(on));
      btn.setAttribute('aria-label', on ? btn.dataset.labelRemove : btn.dataset.labelAdd);
      const txt = $('[data-wishlist-text]', btn);
      if (txt) txt.textContent = on ? txt.dataset.textRemove : txt.dataset.textAdd;
    });
    $$('[data-wishlist-count]').forEach((el) => { el.textContent = list.length > 0 ? list.length : ''; });
  }
  if (T.wishlist) {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-wishlist-toggle]');
      if (!btn) return;
      e.preventDefault();
      const h = btn.dataset.handle;
      let list = store.get(WKEY);
      const adding = !list.includes(h);
      list = adding ? [h, ...list] : list.filter((x) => x !== h);
      store.set(WKEY, list.slice(0, 50));
      syncWishlistUI();
      toast(adding ? T.strings.wishlistAdded : T.strings.wishlistRemoved);
      const page = btn.closest('[data-product-list="wishlist"]');
      if (page && !adding) { const card = btn.closest('li'); if (card) card.remove(); if (!$('li', page)) renderProductList(page); }
    });
    syncWishlistUI();
  }

  /* ---------- Client-rendered product lists (recently viewed + wishlist) ---------- */
  async function fetchCard(handle) {
    try {
      const res = await fetch(`${root}/products/${encodeURIComponent(handle)}?section_id=product-card-render`);
      if (!res.ok) return null;
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      return $('.product-card', doc);
    } catch (e) { return null; }
  }

  async function renderProductList(wrap) {
    const type = wrap.dataset.productList;
    const limit = parseInt(wrap.dataset.limit, 10) || 8;
    const exclude = wrap.dataset.exclude;
    const handles = store.get(type === 'wishlist' ? WKEY : 'ambient:recent').filter((h) => h !== exclude).slice(0, limit);
    const grid = $('[data-list-grid]', wrap);
    const empty = $('[data-list-empty]', wrap);
    const section = wrap.closest('[data-hide-when-empty]');
    if (!handles.length) {
      if (grid) grid.innerHTML = '';
      if (empty) empty.hidden = false;
      if (section) section.hidden = true;
      return;
    }
    const cards = (await Promise.all(handles.map(fetchCard))).filter(Boolean);
    if (!cards.length) { if (section) section.hidden = true; if (empty) empty.hidden = false; return; }
    grid.innerHTML = '';
    cards.forEach((card) => { const li = document.createElement('li'); li.appendChild(document.importNode(card, true)); grid.appendChild(li); });
    if (empty) empty.hidden = true;
    if (section) section.hidden = false;
    syncWishlistUI();
  }
  $$('[data-product-list]').forEach(renderProductList);

  /* ---------- Product recommendations ---------- */
  $$('[data-recommendations]').forEach(async (el) => {
    try {
      const res = await fetch(el.dataset.url);
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const fresh = $('[data-recommendations]', doc);
      if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; syncWishlistUI(); revealAll(el); }
      else el.closest('.shopify-section') && (el.closest('.shopify-section').hidden = true);
    } catch (e) { /* silently skip */ }
  });

  /* ---------- Collection filters ---------- */
  $$('[data-filter-form]').forEach((form) => {
    const go = debounce(() => {
      const params = new URLSearchParams();
      new FormData(form).forEach((v, k) => { if (v !== '') params.append(k, v); });
      window.location.search = params.toString();
    }, 500);
    form.addEventListener('change', go);
    form.addEventListener('submit', (e) => { e.preventDefault(); go(); });
  });
  $$('[data-sort-select]').forEach((sel) => sel.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sel.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  }));

  /* ---------- Reveal on scroll ---------- */
  let io;
  function revealAll(ctx = document) {
    const els = $$('.reveal:not(.is-in)', ctx);
    if (!document.body.classList.contains('has-reveal') || !('IntersectionObserver' in window)) { els.forEach((el) => el.classList.add('is-in')); return; }
    io = io || new IntersectionObserver((entries) => entries.forEach((en) => {
      if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
    }), { rootMargin: '0px 0px -8% 0px' });
    els.forEach((el) => io.observe(el));
  }
  revealAll();

  /* ---------- Theme editor support ---------- */
  document.addEventListener('shopify:section:load', (e) => {
    revealAll(e.target);
    $$('[data-product-section]', e.target).forEach(initProduct);
    $$('[data-product-list]', e.target).forEach(renderProductList);
    syncWishlistUI();
  });


  /* ---------- Measure header height (hero sits beneath the glass header) ---------- */
  const hdrSection = $('.section-header');
  if (hdrSection) {
    const setH = () => document.documentElement.style.setProperty('--header-h', hdrSection.offsetHeight + 'px');
    setH();
    if ('ResizeObserver' in window) new ResizeObserver(setH).observe(hdrSection);
  }

  /* ---------- Hero slideshow ---------- */
  $$('[data-hero]').forEach((hero) => {
    const slides = $$('[data-hero-slide]', hero);
    const dots = $$('[data-hero-dot]', hero);
    if (slides.length < 2) return;
    let i = 0; let timer;
    const go = (n) => {
      slides[i].classList.remove('is-active'); if (dots[i]) dots[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active'); if (dots[i]) dots[i].classList.add('is-active');
    };
    const play = () => { clearInterval(timer); timer = setInterval(() => go(i + 1), (parseInt(hero.dataset.speed, 10) || 7) * 1000); };
    dots.forEach((d, n) => d.addEventListener('click', () => { go(n); play(); }));
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) play();
  });

  /* ---------- Tabs with sliding pill ---------- */
  function initTabs(scope) {
    $$('[data-tabs]', scope).forEach((tabs) => {
      const btns = $$('[role="tab"]', tabs);
      const pill = $('[data-tabs-pill]', tabs);
      const place = (b) => { if (pill && b) { pill.style.left = b.offsetLeft + 'px'; pill.style.width = b.offsetWidth + 'px'; } };
      const select = (b) => {
        btns.forEach((x) => { const on = x === b; x.setAttribute('aria-selected', String(on)); x.tabIndex = on ? 0 : -1; const panel = document.getElementById(x.getAttribute('aria-controls')); if (panel) panel.hidden = !on; });
        place(b);
        const panel = document.getElementById(b.getAttribute('aria-controls'));
        if (panel) revealAll(panel);
      };
      btns.forEach((b, n) => {
        b.addEventListener('click', () => select(b));
        b.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { const nb = btns[(n + (e.key === 'ArrowRight' ? 1 : -1) + btns.length) % btns.length]; nb.focus(); select(nb); } });
      });
      requestAnimationFrame(() => place(btns.find((b) => b.getAttribute('aria-selected') === 'true') || btns[0]));
      window.addEventListener('resize', debounce(() => place(btns.find((b) => b.getAttribute('aria-selected') === 'true')), 150));
    });
  }
  initTabs(document);

  /* ---------- Countdown ---------- */
  function initCountdowns(scope) {
    $$('[data-countdown]', scope).forEach((el) => {
      const end = Date.parse(el.dataset.end);
      if (isNaN(end)) return;
      const units = { d: $('[data-d]', el), h: $('[data-h]', el), m: $('[data-m]', el), s: $('[data-s]', el) };
      const tick = () => {
        let diff = Math.max(0, end - Date.now());
        const d = Math.floor(diff / 864e5); diff -= d * 864e5;
        const h = Math.floor(diff / 36e5); diff -= h * 36e5;
        const m = Math.floor(diff / 6e4); diff -= m * 6e4;
        const sec = Math.floor(diff / 1e3);
        const pad = (x) => String(x).padStart(2, '0');
        if (units.d) units.d.textContent = pad(d); if (units.h) units.h.textContent = pad(h);
        if (units.m) units.m.textContent = pad(m); if (units.s) units.s.textContent = pad(sec);
        if (end <= Date.now()) { clearInterval(t); const sec2 = el.closest('[data-hide-when-ended]'); if (sec2) sec2.hidden = true; }
      };
      const t = setInterval(tick, 1000); tick();
    });
  }
  initCountdowns(document);

  /* ---------- Scent finder quiz (stepper) → Ambient AI ---------- */
  $$('[data-finder]').forEach((form) => {
    const steps = $$('[data-step]', form);
    const wrap = form.closest('[data-finder-wrap]');
    const bar = wrap && $('[data-finder-bar]', wrap);
    const count = wrap && $('[data-finder-count]', wrap);
    const back = $('[data-finder-back]', form), next = $('[data-finder-next]', form), submit = $('[data-finder-submit]', form);
    let i = 0;
    const go = (n) => {
      const dir = n > i ? 1 : -1;
      steps[i].classList.remove('is-active'); steps[i].classList.add(dir > 0 ? 'is-leaving' : 'is-leaving-back');
      const old = steps[i]; setTimeout(() => old.classList.remove('is-leaving', 'is-leaving-back'), 450);
      i = Math.max(0, Math.min(steps.length - 1, n));
      steps[i].classList.add('is-active');
      if (bar) bar.style.transform = 'scaleX(' + ((i + 1) / steps.length) + ')';
      if (count) count.textContent = 'Step ' + (i + 1) + ' of ' + steps.length;
      back.hidden = i === 0;
      const multi = steps[i].hasAttribute('data-multi');
      next.hidden = !multi || i === steps.length - 1;
      submit.hidden = i !== steps.length - 1;
    };
    form.addEventListener('change', (e) => {
      const step = e.target.closest('[data-step]');
      if (!step) return;
      const max = parseInt(step.dataset.multi, 10);
      if (max) {
        const checked = $$('input:checked', step);
        if (checked.length > max) e.target.checked = false;
        return;
      }
      if (steps.indexOf(step) < steps.length - 1) setTimeout(() => go(steps.indexOf(step) + 1), 220);
    });
    back.addEventListener('click', () => go(i - 1));
    next.addEventListener('click', () => go(i + 1));
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const fd = new FormData(form);
      const vibes = fd.getAll('vibe').join(' and ');
      const q = [vibes ? vibes + ' perfume' : 'perfume', fd.get('who'), fd.get('when'), fd.get('strength'), fd.get('budget')].filter(Boolean).join(' ').replace(/\s+/g, ' ').trim();
      window.dispatchEvent(new CustomEvent('ambient:ai', { detail: { q } }));
      if (!window.AmbientAIEngine) window.location.href = (T.routes.search || '/search') + '?q=' + encodeURIComponent(q) + '&type=product';
    });
    go(0);
  });

  /* ---------- Offer flip cards (3D flip + fluid tilt + copy code) ---------- */
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-flip-toggle]');
    if (t) {
      const card = t.closest('[data-flip]');
      const on = !card.classList.contains('is-flipped');
      card.classList.toggle('is-flipped', on);
      const front = $('.flip__front', card);
      front.setAttribute('aria-expanded', String(on));
      setTimeout(() => { const f = on ? $('.flip__back a, .flip__back button', card) : front; if (f) f.focus({ preventScroll: true }); }, 350);
      return;
    }
    const c = e.target.closest('[data-copy]');
    if (c) {
      const code = c.dataset.copy;
      (navigator.clipboard ? navigator.clipboard.writeText(code) : Promise.reject()).then(() => toast('Code ' + code + ' copied ✓'), () => toast('Your code: ' + code));
    }
  });
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    $$('[data-flip]').forEach((card) => {
      let raf = 0;
      card.addEventListener('pointermove', (e) => {
        if (raf) return;
        raf = requestAnimationFrame(() => {
          const r = card.getBoundingClientRect();
          card.style.setProperty('--rx', ((0.5 - (e.clientY - r.top) / r.height) * 10).toFixed(2) + 'deg');
          card.style.setProperty('--ry', (((e.clientX - r.left) / r.width - 0.5) * 12).toFixed(2) + 'deg');
          card.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
          raf = 0;
        });
      });
      card.addEventListener('pointerleave', () => { card.style.setProperty('--rx', '0deg'); card.style.setProperty('--ry', '0deg'); });
    });
  }

  /* ---------- Hero: wipe the mist ---------- */
  $$('[data-mist]').forEach((hero) => {
    const canvas = $('[data-mist-canvas]', hero);
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!canvas || !canvas.getContext) return;
    const ctx = canvas.getContext('2d');
    const img = $('.mist__media img', hero);
    const hint = $('[data-mist-hint]', hero);
    const notesWrap = $('[data-mist-notes]', hero);
    const strength = (parseInt(hero.dataset.strength, 10) || 80) / 100;
    const SCALE = 0.5; // half resolution: mist is soft, so this halves the work
    let W = 0, H = 0, fog = null, active = false, visible = true, lastWipe = 0, raf = 0, last = null;

    const buildFog = () => {
      const rect = hero.getBoundingClientRect();
      W = Math.max(1, Math.round(rect.width * SCALE)); H = Math.max(1, Math.round(rect.height * SCALE));
      canvas.width = W; canvas.height = H;
      fog = document.createElement('canvas'); fog.width = W; fog.height = H;
      const f = fog.getContext('2d');
      // frosted copy of the image when the browser supports canvas filters
      if (img && img.complete && img.naturalWidth && 'filter' in f) {
        const ir = img.naturalWidth / img.naturalHeight, cr = W / H;
        let dw = W, dh = H, dx = 0, dy = 0;
        if (ir > cr) { dw = H * ir; dx = (W - dw) / 2; } else { dh = W / ir; dy = (H - dh) / 2; }
        f.filter = 'blur(14px) saturate(120%)';
        try { f.drawImage(img, dx - 20, dy - 20, dw + 40, dh + 40); } catch (e) { /* ignore */ }
        f.filter = 'none';
      }
      const g = f.createLinearGradient(0, 0, W, H);
      g.addColorStop(0, 'rgba(250,246,252,' + (0.55 + strength * 0.4) + ')');
      g.addColorStop(0.55, 'rgba(240,231,248,' + (0.45 + strength * 0.4) + ')');
      g.addColorStop(1, 'rgba(236,224,214,' + (0.4 + strength * 0.4) + ')');
      f.fillStyle = g; f.fillRect(0, 0, W, H);
      // condensation droplets
      for (let k = 0; k < Math.round(W * H / 900); k++) {
        const x = Math.random() * W, y = Math.random() * H, r = Math.random() * 1.6 + 0.3;
        f.fillStyle = 'rgba(255,255,255,' + (Math.random() * 0.5 + 0.2) + ')';
        f.beginPath(); f.arc(x, y, r, 0, Math.PI * 2); f.fill();
      }
      ctx.globalCompositeOperation = 'source-over';
      ctx.clearRect(0, 0, W, H);
      ctx.drawImage(fog, 0, 0);
      hero.classList.add('is-ready');
    };

    const wipe = (x, y, r) => {
      ctx.globalCompositeOperation = 'destination-out';
      const g = ctx.createRadialGradient(x, y, 0, x, y, r);
      g.addColorStop(0, 'rgba(0,0,0,.95)'); g.addColorStop(0.55, 'rgba(0,0,0,.55)'); g.addColorStop(1, 'rgba(0,0,0,0)');
      ctx.fillStyle = g; ctx.beginPath(); ctx.arc(x, y, r, 0, Math.PI * 2); ctx.fill();
    };
    const stroke = (x, y) => {
      const r = Math.max(28, W * 0.055);
      if (last) {
        const dx = x - last.x, dy = y - last.y, dist = Math.hypot(dx, dy), n = Math.ceil(dist / (r * 0.35));
        for (let k = 1; k <= n; k++) wipe(last.x + dx * k / n, last.y + dy * k / n, r);
      } else wipe(x, y, r);
      last = { x, y };
      lastWipe = performance.now();
      if (hint) hint.classList.add('is-gone');
      kick();
    };
    // slow re-fogging, only while recently interacted & on screen
    const loop = () => {
      raf = 0;
      if (!visible || !fog) { active = false; return; }
      const idle = performance.now() - lastWipe;
      if (idle > 9000) { active = false; return; }
      if (idle > 900) { ctx.globalCompositeOperation = 'source-over'; ctx.globalAlpha = 0.018; ctx.drawImage(fog, 0, 0); ctx.globalAlpha = 1; }
      raf = requestAnimationFrame(loop);
    };
    const kick = () => { if (!active) { active = true; raf = requestAnimationFrame(loop); } };

    const pos = (e) => { const r = canvas.getBoundingClientRect(); return { x: (e.clientX - r.left) * SCALE, y: (e.clientY - r.top) * SCALE }; };
    hero.addEventListener('pointermove', (e) => {
      if (e.pointerType === 'mouse' || e.buttons || e.pointerType === 'pen' || e.pointerType === 'touch') { const p = pos(e); stroke(p.x, p.y); }
      if (notesWrap && e.pointerType === 'mouse') {
        const r = hero.getBoundingClientRect();
        notesWrap.style.setProperty('--px', (((e.clientX - r.left) / r.width - 0.5) * -18).toFixed(1) + 'px');
        notesWrap.style.setProperty('--py', (((e.clientY - r.top) / r.height - 0.5) * -14).toFixed(1) + 'px');
      }
    }, { passive: true });
    hero.addEventListener('pointerleave', () => { last = null; });
    hero.addEventListener('pointerdown', (e) => { last = null; const p = pos(e); wipe(p.x, p.y, Math.max(46, W * 0.09)); stroke(p.x, p.y); });

    if ('IntersectionObserver' in window) new IntersectionObserver(([en]) => { visible = en.isIntersecting; if (visible && performance.now() - lastWipe < 9000) kick(); }).observe(hero);

    const intro = () => {
      if (reduce) { ctx.clearRect(0, 0, W, H); ctx.globalAlpha = 1; ctx.drawImage(fog, 0, 0); return; }
      // a gentle automatic swipe hints at the interaction
      const t0 = performance.now(), dur = 1500;
      const pts = (t) => ({ x: W * (0.48 + 0.42 * t), y: H * (0.72 - 0.42 * Math.sin(t * Math.PI)) });
      last = null;
      const step = (now) => {
        const t = Math.min(1, (now - t0) / dur);
        const p = pts(t * t * (3 - 2 * t));
        stroke(p.x, p.y);
        if (t < 1) requestAnimationFrame(step); else { last = null; if (hint) hint.classList.remove('is-gone'); }
      };
      requestAnimationFrame(step);
    };
    const start = () => { buildFog(); setTimeout(intro, 450); };
    if (!img || img.complete) start(); else { img.addEventListener('load', start, { once: true }); setTimeout(() => { if (!fog) start(); }, 2500); }
    window.addEventListener('resize', debounce(() => { const before = W; const r = hero.getBoundingClientRect(); if (Math.abs(r.width * SCALE - before) > 20) buildFog(); }, 250));
  });

  /* ---------- Collection: load more + grid density ---------- */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-load-more]');
    if (!btn) return;
    e.preventDefault();
    const sectionId = btn.dataset.sectionId;
    const url = btn.getAttribute('href');
    btn.classList.add('is-loading');
    try {
      const res = await fetch(url + (url.includes('?') ? '&' : '?') + 'section_id=' + sectionId);
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const grid = $('[data-product-grid]');
      $$('[data-product-grid] > li', doc).forEach((li) => grid.appendChild(document.importNode(li, true)));
      const fresh = $('[data-load-more-wrap]', doc);
      const wrap = $('[data-load-more-wrap]');
      if (wrap) { if (fresh) wrap.replaceWith(fresh); else wrap.remove(); }
      revealAll(grid); syncWishlistUI();
      window.history.replaceState({}, '', url);
    } catch (err) { window.location.href = url; }
  });
  $$('[data-grid-toggle]').forEach((wrap) => {
    const grid = $('[data-product-grid]');
    if (!grid) return;
    const btns = $$('button', wrap);
    const setCols = (c) => { grid.style.setProperty('--cols', c); btns.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.cols === String(c)))); try { localStorage.setItem('ambient:cols', c); } catch (e) { /* ignore */ } };
    btns.forEach((b) => b.addEventListener('click', () => setCols(b.dataset.cols)));
    let saved = null; try { saved = localStorage.getItem('ambient:cols'); } catch (e) { /* ignore */ }
    if (saved && btns.some((b) => b.dataset.cols === saved)) setCols(saved);
  });

  /* ---------- Dispatch countdown (PDP + cart drawer) ---------- */
  const dispatchTimers = new WeakMap();
  function initDispatch(scope) {
    const els = scope && scope.matches && scope.matches('[data-dispatch]') ? [scope] : $$('[data-dispatch]', scope || document);
    els.forEach((el) => {
      if (dispatchTimers.has(el)) return;
      const cutoff = parseInt(el.dataset.cutoff, 10) || 14;
      const out = $('[data-dispatch-text]', el);
      if (!out) return;
      const update = () => {
        if (!el.isConnected) { clearInterval(dispatchTimers.get(el)); return; }
        const now = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/London' }));
        const day = now.getDay();
        const mins = now.getHours() * 60 + now.getMinutes();
        const weekday = day >= 1 && day <= 5;
        if (weekday && mins < cutoff * 60) {
          const left = cutoff * 60 - mins;
          out.innerHTML = 'Order within <strong>' + Math.floor(left / 60) + 'h ' + (left % 60) + 'm</strong> for same-day dispatch';
        } else {
          const next = (day === 5 || day === 6 || day === 0) ? 'Monday' : 'tomorrow';
          out.innerHTML = 'Order now for dispatch <strong>' + next + '</strong>';
        }
      };
      update(); dispatchTimers.set(el, setInterval(update, 60000));
    });
  }
  initDispatch(document);

  /* ---------- Gallery zoom ---------- */
  document.addEventListener('click', (e) => {
    const img = e.target.closest('.gallery__slide img');
    if (!img || window.matchMedia('(hover: none)').matches) return;
    const slide = img.closest('.gallery__slide');
    slide.classList.toggle('is-zoomed');
  });
  document.addEventListener('mousemove', (e) => {
    const slide = e.target.closest('.gallery__slide.is-zoomed');
    if (!slide) return;
    const r = slide.getBoundingClientRect();
    $('img', slide).style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
  });

  /* ---------- Theme editor support for new modules ---------- */
  document.addEventListener('shopify:section:load', (e) => { initTabs(e.target); initCountdowns(e.target); });

  window.Ambient = { openDrawer, closeDrawer, refreshCart, renderCartDrawer, changeLine, toast, revealAll, syncWishlistUI, initTabs, debounce, store };
})();
